
import { Component, ViewEncapsulation,  } from '@angular/core';
import { UtilService } from '../services/util.service';
import { interval, Observable, Subscription } from 'rxjs';
import { GlobalsService } from '../services/globals.service';

import { SocketIO } from '../services/io.service';

import { Els } from '../services/els.service';
// import { MatExpansionModule } from '@angular/material/expansion';
import { Storage } from '@capacitor/storage';
// import { Contacts } from '@capacitor-community/contacts'

// import * as JsSIP from '../services/jssip.js';

@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['home.page.scss'],
})

// export class HomePage implements OnInit {
export class HomePage {

  results: Observable<any>;
  retData: any;
  keys: Object;
  subscription: Subscription;

  private TIMER = 0;

  constructor(
    private gs: GlobalsService,
    private io: SocketIO,
    private els: Els,
    private util: UtilService,
    // private matExpansionModule: MatExpansionModule,
  ) { 
    window.addEventListener('load', (event) => {  
    console.log('page is fully loaded ' + event.type.toString());

    //////////////////////////////////////////

    // this.getConts ();

  });

  console.log(`took ` + (performance.now() - 1));
      // if (window) {
        window.console.log = function () { };
        window.console.error = function () { };
      // }
  
  this.goLogin ();
}

async removeItem(key: string) { await Storage.remove({ key });}

blockIPdebug () {
  if (this.gs.authIpDebug != this.retData['source_ip']){
    if (window) {
      window.console.log = function () { };
      window.console.error = function () { };
    }
  }
}

goLogin () { 
    this.gs.stTime = performance.now();
    this.util.getDevInfo().then (res => {
      this.util.getDevLocalSsettings ();
      if (this.gs.rpsw != '') {this.retData = this.goLoginUrl ();}
      else this.showLogin(1);
      console.log(`took ` + (performance.now() - this.gs.stTime));
    });
}

starttimer_60() {
  let tle = document.getElementById('tiId');
  
  const source = interval(1 * 1000);
  this.subscription = source.subscribe(val => {

    // if (this.sokio.soc === undefined || this.sokio.soc.readyState != 1) {
    // if (this.gs.isOnline == 0) { this.sokio.goOnline ();}

    if (this.gs.refreshTimer != -1) {
      this.gs.timerLable (tle, this.TIMER);
      if ( this.gs.refreshTimer <= this.TIMER ) { this.TIMER = 0;  this.goRefresh('N'); }
      this.TIMER ++;
    }

  });
}

starttimer(mils: number) {
  console.log('STARTTTTTTTTTTTTTTTTTTTTTTTTT');
  let selReset = -1;
  const source = interval(mils);
  this.subscription = source.subscribe(val => {
    if (this.gs.pathSelected > -1) {
      selReset++;
      let mid = this.gs.getID (this.gs.pathSelected);
      if (document.getElementById (mid) !== null) {
        this.util.getItemClick( mid, 0);
        this.gs.pathSelected = -1;
        console.log('DONEEEEEEEEEEEEEEEEEEEEEEE');
      }
      if (selReset * mils > 5000) this.gs.pathSelected = -1;
      console.log(selReset);
    }
    // else kill testttttttttttttttttttttttttt
  });
}

chkUrlPath () {
  //2134467856
  // a.reachme.com/tmp/a/index.php/_msg3f4db913-ecfc-4adb-826b-e232d5080525.wav
  if (this.gs.path != '') {
    if (this.gs.path.indexOf('_msg') == 0) {
      let s = this.gs.path.replace('_msg', '');
      s = s.substring(0, s.length - 4)
      this.gs.pathSelected = this.gs.findInItems_uuid (s);
      if (this.gs.pathSelected > -1) this.starttimer(250);
    }
    this.gs.path = '';
  }
}

async goLoginUrl () {
  this.results = this.gs.postUrl (this.gs.reachmeUrl, this.gs.getMsgs_Postdata());
  this.results.subscribe( res => { 
    if (this.parseNew_retData (res, 1) == 0) { this.showLogin(0); return 0; }
    this.logMeIn ();
    this.chkUrlPath () ;
  }, error => { this.els.postUrl_error (JSON.stringify(error)); this.showLogin(0);});
}

logMeIn () {
  this.blockIPdebug();
  this.gs.localstorage_set_rpsw (this.retData);
 
  this.gs.ITMS = new Array ();
  for(let ii=this.gs.msgsGTlocalStoreArr.length - 1; ii >= 0; ii--) {
    this.gs.msgsGTtmp_push (this.gs.msgsGTlocalStoreArr[ii], 0, '', 0);
  }
  this.insLoginITMS ('New');
  this.showMsgFilters (1);
}

goRefresh (mg) { 
  this.results = this.gs.postUrl (this.gs.reachmeUrl, this.gs.goRefresh_Postdata (mg));
  this.results.subscribe( res => {
    if (this.parseNew_retData (res, 0) == 0) return 0;
    this.insRefreshITMS ();
  }, error => {this.els.postUrl_error (JSON.stringify(error));});
}

goClearLS () {
  this.gs.showAlert('Clear Local Storage and resync with server?', 'It Will Logpot', '').then (res => {
    if (this.gs.resultRet == '1') {

      let uname = this.gs.get_LS('uname');
      let upsw = this.gs.get_LS('upsw');

      localStorage.clear();

      this.gs.set_LS('uname', uname);
      this.gs.set_LS('upsw', upsw);

      window.location.reload ();
    }
  })
}

insRefreshITMS () {
  let ind = 0; let a; let play = 0;
  if (this.gs.msgsGTtmp.length == 0) return;
  let c = this.gs.ITMS.length;
  this.gs.msgsGTtmp.sort((a, b) => { return b['d'] - a['d']; });
  
  for(let i=this.gs.msgsGTtmp.length - 1; i >= 0; i--) { 

    this.gs.ITMS.splice(ind, 0, this.gs.msgsGTtmp[i]);
    a = this.gs.getAssocMsgArray (ind);
    this.gs.ITMS[ind]['t'] = this.gs.getTag ( a, this.gs.ITMS[ind]  );
    this.gs.getBlks (this.gs.ITMS[ind]);
    if (a['p_fix'] == 'm_' && a['type'] == this.gs.MSGS_TYPE_VOICEMAIL) {
      this.util.showHideEl (ind, 1, 0, 1);
      play = 1;
    }

  }
  this.gs.removeDupReports();
  this.gs.localstorage_set ();
  this.els.updateGSbadges ();

  if (play == 1 && this.gs.timerON == 2) this.playit ('')
  this.els.setInnerHDat ('totmsgs', 'Total ' + this.gs.msgsAllTotal);
  if (this.gs.ITMS.length > c) this.gs.presentToast((this.gs.ITMS.length - c) + ' Items Are Downloaded', 'success', 1000).then (res => {});
}

insLoginITMS ( segSel) {
  if (this.gs.msgsGTtmp.length == 0) return;
  this.gs.msgsGTtmp.sort((a, b) => { return b['d'] - a['d']; });
  let i = 0;
  for(i = 0; i < this.gs.msgsGTtmp.length ; i++) {this.gs.ITMS.push (this.gs.msgsGTtmp[i]);}
  this.gs.removeDupReports();
  this.gs.getTags ();
  this.gs.localstorage_set ();
  this.util.refreshItemsVis (segSel, 1); 
  this.els.setInnerHDat ('totmsgs', 'Total ' + this.gs.msgsAllTotal);
}

showMsgFilters (isLogin) {  // setfocous
  this.els.sh_msgsDiv();
  let e = document.getElementById ('infoMainIco')  ; 

  if (isLogin == 1) {
    let e = document.getElementById("loginDivH");  
    if (e !== null) e.innerHTML = '' ;  
    this.els.sh_mainH (this.gs.showByClass);

    this.getTopHeader ();
    this.goTimerA ();
    this.starttimer_60();

    this.createTabsTop (); 
    this.util.getFooter (); 
  }
}

createTabsTop () {  

  let bar = document.getElementById ('topTabId'); if (bar === null) {console.error('mtab stop'); return;}
  
  let lout = this.els.getTab ('', this.gs.ICO_LOGOUT, 'Logout');
  if (lout !== null) lout.addEventListener("click", () => { this.gs.logout (1); });

  let ref = this.els.getTab ('', 'refresh', 'Older Msgs');
  if (ref !== null) ref.addEventListener("click", () => { this.goRefresh('G');})

  let cl = this.els.getTab ('', this.gs.ICO_RELOAD, 'Clear Storage');
  if (cl !== null) cl.addEventListener("click", () => { this.goClearLS();});

  bar.appendChild(lout);
  bar.appendChild(cl);
  bar.appendChild(ref);

}

loginClick () {
  this.els.getLogin();
  this.retData = this.goLoginUrl ();
}



async showLogin (isNew) {

  this.els.showLoginDivs ();
  if (isNew == 0) return;

  let p;

  let dh = document.getElementById("loginDivH");
  if (dh != null) dh.innerHTML = `<div><img style="margin: 10px;" src="/assets/img/ReachMeLogo.gif" class="logo" alt="ReachMe logo"></div>`;

  // if (this.gs.username == '') {
     this.gs.username = this.gs.get_LS('uname');
      // this.gs.upsw = this.gs.get_LS('upsw');
      // if (this.gs.upsw != '') 
      //   this.gs.upsw = await this.els.decode(this.gs.duuid, this.gs.upsw);
        
  // }

  let d = document.getElementById("loginDiv"); if (d == null) return;
  d.innerHTML = '';
  let div = this.els.createElem ('div', '', '', '', 'login');

  let h1 = this.els.createElem ('h1', '', 'Please Login to ReachMe App'); div.appendChild(h1);
  let pt1 = this.els.createElem ('p', 'fb', '', '', 'fb'); div.appendChild(pt1); 

  p = this.els.createElem ('p');
  let uame = this.els.createElem ('input', 'uname');
  uame.setAttribute ( 'type', 'text');
  uame.setAttribute ( 'value', this.gs.username);
  uame.setAttribute('placeholder', 'Username');
  p.appendChild( uame);
  div.appendChild( p);

  p = this.els.createElem ('p', '', '', '', 'remC'); 
  let l2 = this.els.createElem ('label', '', 'Show Password'); 
  let chk = this.els.createElem ('input', 'sh'); 
  chk.setAttribute('type', 'checkbox');
  chk.addEventListener("click", () => { this.showPassword(); });
  l2.appendChild(chk);
  p.appendChild(l2);
  div.appendChild(p);

  p = this.els.createElem ('p');
  let upsw = this.els.createElem ('input', 'upsw');
  upsw.setAttribute('type', 'Password');
  if (this.gs.upsw != '') upsw.setAttribute('value', this.gs.upsw);
  upsw.setAttribute('placeholder', 'Password');
  
  p.appendChild(upsw);
  div.appendChild(p);

  p = this.els.createElem ('p', '', '', '', 'submit');
  let subm = this.els.createElem ('input', 'subm');
  subm.setAttribute('type', 'button');
  subm.setAttribute('value', 'Login');
  subm.addEventListener("click", () => { this.loginClick(); });
  p.appendChild( subm);
  div.appendChild(p);

  d.appendChild(div);

  

  // if (isNEWsignup == 0) {
  //     this.els.hideUnhideElement ('rphone', 'none');
  //     this.els.hideUnhideElement ('remail', 'none');
  // } else {
  //     this.els.hideUnhideElement ('rphone', 'block');
  //     this.els.hideUnhideElement ('remail', 'block');}

}

showPassword() {
  const upsw = document.getElementById("upsw") as HTMLInputElement;
  const p2 = document.getElementById("p2") as HTMLInputElement;
  const sh = document.getElementById("sh") as HTMLInputElement;
  if (sh !== null && upsw !== null) {
      if(sh.checked == true){ upsw.type = 'text'; if (p2 !== null) p2.type = 'text'; }
      else { upsw.type = 'password'; if (p2 !== null) p2.type = 'password'; }
  }
  else {console.error('elemets missing');}
}

goCall() {
  // const to = document.getElementById("callID") as HTMLInputElement;
  // console.error(to.value);
  // this.util.goUrl (this.gs.sms_Postdata ({}, '531', to.value, '', 'call'), '');

 const to = document.getElementById("callnum") as HTMLInputElement;
  console.error(to.value);
  this.io.goCall (to.value);
}

getSearchStr(ev: any) { this.util.getSearchStr(ev); }
mmenuClose() {  this.util.mmenuClose ();}
menuDidClose() { this.els.setInnerHDat ('mmenu', '');}
infoMainClicked () {this.util.infoMainClicked ();}
favIconClicked() { 
  
  this.playit('invitation.mp3');

 // this.util.getFavMenu ();  
}

parseNew_retData (res, isNewCall) {
  if (res === null) { console.error('res = null'); return 0; }
  this.gs.msgsGTtmp = new Array ();
  this.retData = JSON.parse(JSON.stringify(res));
  if (this.postUrl_Iferrmsg () == 0) return 0;
  if (isNewCall == 1) {this.gs.loopLStoreage ();}
  this.gs.parse_retData (this.retData);  // make msgsGTlocalStoreArr
  return 1;
}

postUrl_Iferrmsg () {
  let err = this.retData['errmsg'] !== undefined ? this.retData['errmsg'] : '';
  if (err != '') {
    console.error(err)  ;
    const fb = document.getElementById("fb") as HTMLInputElement;
    if (fb !== null) {fb.innerHTML = err;} 
    this.gs.presentToast(err, 'warning', 2000);
    return 0;
  }
  return 1;
}

logScrolling($event) { this.util.logScrolling($event);}

goTimerA () {
  this.TIMER = 0;
  let badge = document.getElementById('tiId'); if (badge === null) return;
  let ico = document.getElementById('timerIcoID'); if (ico === null) return;

  badge.setAttribute( 'style', 'font-size: 10px; margin-left: -12px; margin-top: 10px;');
  badge.setAttribute( 'color', 'success');

  switch (this.gs.timerON) {
    case 0:
      this.gs.refreshTimer = -1;
      badge.classList.add('hideEl');
      this.els.setIconName ( this.gs.ICO_TIMER, ico);
      ico.setAttribute( 'color', 'danger');
      this.gs.timerON = 1;
    break;

    case 1:
      this.gs.refreshTimer = this.gs.refreshSecs;
      badge.classList.remove('hideEl');
      ico.setAttribute( 'color', 'success');
      
      this.els.setIconName ( this.gs.ICO_BELL, ico);
      this.gs.presentToast('Auto Message Check Every ' + this.gs.refreshTimer + ' Seconds', 'success', 1500); 
      this.gs.timerON = 2;
    break;

    case 2:
      this.els.setIconName ( this.gs.ICO_BELLOFF, ico);
      this.gs.timerON = 0;
    break;

    default:  break;
  }

  this.gs.timerLable (badge, this.TIMER);
}

async playit (fn) {
  if (fn == '') fn = 'invitation.mp3';

  var audio = document.createElement( 'audio' ) as HTMLAudioElement;
  audio.muted = false;
  // audio.autoplay = true;
  audio.src = "/assets/audio/" + fn; 
  audio.play();
  // await this.getVideo (fn);
  audio.onended = function() {   console.log(audio.src);  }
}

localStream=null;

async getVideo (fn) {
    const video: HTMLVideoElement = document.createElement('video');
    video.hidden = false;
    // video.addEventListener("click", () => {console.log("click"); });
    this.localStream = await navigator.mediaDevices.getUserMedia({ video: false, audio: true });
    var src = document.createElement("source"); 
    // sourceMP4.type = "video/mp4";
    src.src =  "/assets/audio/" + fn; 
    video.appendChild(src);
    // video.src = this.localStream ;
    // video.srcObject = this.localStream ;
    // this.getTracks (this.localStream ) ;
    // if ("srcObject" in video) { video.srcObject = this.localStream; }
    // else {   Old version   video.src = window.URL.createObjectURL(this.localStream); }
    // video.muted = true;
    // video.onloadedmetadata = function(e) {
      video.play();
      video.onended = function() {
        video.srcObject = null;
        video.src = null;
        src = null;
        }
    // }

  //   (async () => {
  //     let audio = new Audio();
  //     audio.srcObject = await navigator.mediaDevices.getUserMedia({audio: true, video: false});
  //     audio.play();})();

}

getTopHeader () {
  let mainH = document.getElementById ('mainH');

  let buts = this.els.buttons_El ('slot="start"', '', '---', 'src="assets/icon/refav.ico"', '---');
  buts.addEventListener("click", () => { this.favIconClicked(); }); 
  mainH.appendChild( buts);

  let sear = this.els.createElem ('ion-searchbar', 'sear');
  sear.setAttribute('placeholder', 'Search Numbers, Names, Texts...');
  sear.setAttribute('debounce', '700');
  sear.addEventListener("ionInput", (ev) => { this.getSearchStr(ev); }); 
  sear.addEventListener("ionFocus", () => { this.showMsgFilters(0); }); 
  
  let div = this.els.createElem ('div');
  div.appendChild( sear);
  mainH.appendChild( div);

  buts = this.els.buttons_El (
    'id="timId";; slot="end"',''
  , 'id="timerIcoID";; name="timer-outline";; class="red"', '---'
  , 'id="tiId";; class="hideEl"'
  );
  buts.addEventListener("click", () => { this.goTimerA(); }); 
  mainH.appendChild( buts);

  buts = this.els.buttons_El (
    'slot="end" ;;id="infoMain"', '', 'id="infoMainIco" ;;slot="icon-only";; name="alert-circle-outline"', '---', '---'
  );
  buts.addEventListener("click", () => { this.infoMainClicked(); }); 
  mainH.appendChild( buts);
}

  
  

















ua;
remoteAudio = document.getElementById ('remoteAudio') as HTMLAudioElement;


// // sipConnect (user, psw, server) {
sipConnect () {

  let use = document.getElementById ('user') as HTMLInputElement ;  let user = use.value;
  let ps = document.getElementById ('psw') as HTMLInputElement ;  let psw = ps.value;
  let serve = document.getElementById ('server') as HTMLInputElement ;  let server = serve.value;

  this.io.sipConnect (user, psw, server);

  // // var socket = new JsSIP.WebSocketInterface('wss://a.reachme.com/sock/');
  // var socket = new JsSIP.WebSocketInterface(server);
  // socket.via_transport = "UDP";

  // var configuration = {
  //   sockets : [ socket ],
  //   register: true,
  //   uri : 'sip:'+ user + '@sip2.reachme.com:5060', 
  //   password : psw,
  //   //  ws_servers: "fs1.reachme.com:7856",
  //  registrar_server: 'sip2.reachme.com:5060',
  //  //  use_preloaded_route: true,
  //   register_expires: 700,
  // };
  // this.ua = new JsSIP.UA(configuration);
  // this.ua.start();
  // ​
  // this.ua.on("registered", function(){
  //   console.log( 'registered');
  // });

}






































// goACCGGG () {

//   let S = `
//   <ion-accordion value="first">
//   <ion-item slot="header" color="light">
//     <ion-label>First Accordion</ion-label>
//   </ion-item>
//   <div class="ion-padding" slot="content">
//     First Content
//   </div>
//   </ion-accordion>
//   <ion-accordion value="second">
//   <ion-item slot="header" color="light">
//     <ion-label>Second Accordion</ion-label>
//   </ion-item>
//   <div class="ion-padding" slot="content">
//     Second Content
//   </div>
//   </ion-accordion>
//   <ion-accordion value="third">
//   <ion-item slot="header" color="light">
//     <ion-label>Third Accordion</ion-label>
//   </ion-item>
//   <div class="ion-padding" slot="content">
//     Third Content
//   </div>
//   </ion-accordion>
//   `

//   let pt1 = this.els.createElem ('ion-accordion-group');

//   let div = document.getElementById('acg')
//   // pt1.innerHTML = S;

//   let ac = this.getAcord ();
//   div.appendChild(ac)
// }




  // <ion-card (click)="expandItem(item)" *ngFor="let item of items">
  //   <ion-card-header>
  //     <ion-card-title>My Neighbor Totoro</ion-card-title>
  //   </ion-card-header>
  //   <ion-card-content>
  //     <app-accordion expandHeight="100px" [expanded]="item.expanded">
  //       <p>Hello there.</p>
  //       <p>Hello there.</p>
  //       <p>Hello there.</p>
  //     </app-accordion>
  //   </ion-card-content>
  // </ion-card>

  // <div #expandWrapper class="acc-max-class" [class.acc-min-class]="!expanded">

  
  // <ion-accordion-group>
    // <ion-accordion value="first">
    //   <ion-item slot="header" color="light">
    //     <ion-label>First Accordion</ion-label>
    //   </ion-item>
    //   <div class="ion-padding" slot="content"> First Content  </div>
    // </ion-accordion>
// </ion-accordion-group>

// getAccoItem (group, val, l, cont) {

//   let accordion = this.els.createElem ('ion-accordion');
//   accordion.setAttribute( 'value', val);

//   let item = this.els.createElem ('ion-item');
//   item.setAttribute( 'slot', 'header');

//   let label = this.els.createElem ('ion-label', '', l);
//   item.appendChild( label);

//   let div = this.els.createElem ('div', '', cont);
//   div.setAttribute( 'class', 'ion-padding');
//   div.setAttribute( 'slot', 'content');

//   accordion.appendChild( item);
//   accordion.appendChild( div);

//   group.appendChild( accordion);
//   return accordion;
//   }


// getAcord ( ) {
//   let group = this.els.createElem ('ion-accordion-group', 'ag');
//   group.addEventListener ("click", () => { this.toggleAccordion(group.v);});
  
//   this.getAccoItem (group, 'first', 'First Accordion', 'First Content');
//   this.getAccoItem (group, 'second', 'second Accordion', 'second Content');
//   this.getAccoItem (group, 'third', 'third Accordion', 'third Content');

//   // group.value = 'second';
//   // let test = document.getElementById('test'); 
//   // test.appendChild(group);
//  console.log(group);

//  return group;


// }



// toggleAccordion (v) {
//   console.log(v)
//     // if (v === 'second') {
//     //   group.value = undefined;
//     // } else {
//     //   group.value = 'second';
//     // }
// }


// getAcc (id, title) {

//   let div = this.els.createElem ('div', id);
//   div.setAttribute( 'class', 'acc-max-class');
//   let card = this.els.createElem ('ion-card');
//   let cardHead = this.els.createElem ('ion-card-heade');
//   let cardTitle = this.els.createElem ('ion-card-title', '', title); 
//   let cardContent = this.els.createElem ('ion-card-content'); 
//   let acc = this.els.createElem ('app-accordion'); 

//   card.appendChild( cardHead);
//   cardHead.appendChild( cardTitle);
//   cardContent.appendChild(acc);
//   card.appendChild(cardContent);
//   div.appendChild(card);

//   acc.setAttribute('expandHeight', '100px');

//   card.addEventListener("click", () => { this.expandItem(id)});

//   const e = document.getElementById('test');
//   if (e !== null) e.appendChild( div);
// }

// expandItem(id) {
//   let div = document.getElementById(id);
//   if (div?.classList.contains('acc-min-class')) {
//       this.els.addRemClass_e (div, 'acc-min-class', 0)
//       this.els.addRemClass_e (div, 'acc-max-class', 1)
//   } 
//   else {
//       div.setAttribute("style", 'max-height:150px;');
//       this.els.addRemClass_e (div, 'acc-max-class', 0)
//       this.els.addRemClass_e (div, 'acc-min-class', 1)
//   }
// }









    // capture (){
    //   // Step - 1.Checking Device Support
    // if (
    //   "mediaDevices" in navigator &&
    //   "getUserMedia" in navigator.mediaDevices
    // ) {
    //   defaultsOpts.video = { facingMode: state?.shouldFaceUser ? 'user' : 'environment',
    //    width: window.screen.height, height: window.screen.width,
    //    }
    
    //   // Requesting user permission
    //   navigator.mediaDevices
    //     .getUserMedia(defaultsOpts)
    //     .then((stream) => {
    //       // video element
    //       window.videoElement = document.getElementById("preview");
    //       window.stream = stream;
    //       window.track = window?.stream?.getVideoTracks()[0];
    
    //       if('srcObject' in window.videoElement){
    //         window.videoElement.srcObject = window.stream;
    //       }else{
    //         // older version
    //         window.videoElement.src = window.URL.createObjectURL(window.stream);
    //       }
    //       window.videoElement.captureStream =
    //       window.videoElement.captureStream || window.videoElement.mozCaptureStream;
    //         return new Promise(resolve => window.videoElement.onplaying = resolve)
    //     })
    //     .catch((log) => {
    //       alert("User Denied accessing camera & audio device", log);
    //     });
    // }else{
    //   alert("your browser does not support camera")
    // }
    // }
    // // capture();



    

// async getConts () {
//   let s = '';
//   try {
// let per = await Contacts.getPermissions ();
// document.getElementById('aclllg').innerHTML = ' >>> ' + per.granted;
// return;

//   await Contacts.getContacts().then(result => {
//     console.log(result);
//     s += '#### '
//     for (const contact of result.contacts) {
//         // console.log(contact);
//         s += contact + '<br>++ '
//     }
//     document.getElementById('aclllg').innerHTML = ' ************* ' + s;
//   });
// } catch (e) {s = ' ---- ' +e; console.error(e);}
  
// if (s != '') document.getElementById('aclllg').innerHTML = ' ++++++++++++ ' + s;
// }


}
